'use client'
export const DescriptionSection = async ({
  logo,
  description,
}: {
  logo?: any
  description?: string
}) => {
  return (
    <div className="hidden md:flex md:flex-col space-y-6">
      {/* Logo */}
      {logo?.url && (
        <div className="relative">
          <div
            className="mb-4"
            onClick={() => {
              window.location.href = '/'
            }}
          >
            <img
              src={logo?.url || '/footer-logo.svg'}
              alt="Titan Fence & Supply Company"
              className="h-32 w-auto object-contain filter brightness-0 invert"
            />
          </div>
        </div>
      )}

      {/* Description */}
      <p className="text-gray-300 leading-relaxed max-w-lg">{description}</p>
    </div>
  )
}
